import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import { styled } from '../../../../lib/stitches'

export const Root = styled(ScrollAreaPrimitive.Root, {
  flex: 1,
  userSelect: 'none',
  touchAction: 'none',
  overflow: 'hidden',
  borderRadius: '4px',
  border: '1px solid rgba(0,0,0,.3)'
})

export const Viewport = styled(ScrollAreaPrimitive.Viewport, {
  width: '100%',
  height: '100%',
  borderRadius: 'inherit'
})

export const SCROLLBAR_SIZE = 10

export const Scrollbar = styled(ScrollAreaPrimitive.Scrollbar, {
  display: 'flex',
  // ensures no selection
  userSelect: 'none',
  // disable browser handling of all panning and zooming gestures on touch devices
  touchAction: 'none',
  padding: 2,
  background: '#E7E7E7',
  transition: 'all 100ms ease-out',
  '&[data-orientation="vertical"]': { width: SCROLLBAR_SIZE },
  '&[data-orientation="horizontal"]': {
    flexDirection: 'column',
    height: SCROLLBAR_SIZE
  }
})

export const Thumb = styled(ScrollAreaPrimitive.Thumb, {
  flex: 1,
  borderRadius: SCROLLBAR_SIZE,
  background: 'rgba(0,0,0,.3)',
  position: 'relative',
  '&:hover': {
    background: 'rgba(0,0,0,.6)'
  },
  '&::before': {
    content: '',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    minWidth: SCROLLBAR_SIZE,
    minHeight: SCROLLBAR_SIZE
  }
})

export const Corner = styled(ScrollAreaPrimitive.Corner, {
  background: 'transparent'
})
